import { FC } from "react";

import { TranslateTextKeyType, useTranslate } from "./useTranslate";

interface Props {
  textKey: TranslateTextKeyType;
  params?: Record<string, string | number | undefined | null>;
  children?: (text: string) => string;
  allowHtml?: boolean;
}

const Translated: FC<Props> = ({ textKey, params, children, allowHtml }) => {
  const translate = useTranslate();

  const text = children
    ? children(translate(textKey, params))
    : translate(textKey, params);

  return allowHtml ? <span dangerouslySetInnerHTML={{ __html: text }} /> : text;
};

export default Translated;
